import { useContext, useMemo } from "react";
import { LocalizationContext } from "../../../core/localization/Localization";
import { Column } from "material-table";
import { SecurityAccounts } from "../../../data/models";

export function useSecAccountColumns() {
  const { getString } = useContext(LocalizationContext);
  return useMemo(
    () => [
      {
        title: getString("portfSecAccount"),
        field: "accNo",
      },
      {
        title: getString("domForMarket"),
        field: "accUse",
      },
      {
        title: getString("domForDefDom"),
        field: "defDom",
      },
      {
        title: getString("domForDefFor"),
        field: "defFor",
      },
    ],
    [getString]
  ) as Column<SecurityAccounts>[];
}
